/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EligibilityRequestServiceTypeCodes
 */
export interface EligibilityRequestServiceTypeCodes {
    /**
     * 
     */
    serviceTypeCode?: Array<string>;
}

/**
 * Check if a given object implements the EligibilityRequestServiceTypeCodes interface.
 */
export function instanceOfEligibilityRequestServiceTypeCodes(value: object): value is EligibilityRequestServiceTypeCodes {
    return true;
}

export function EligibilityRequestServiceTypeCodesFromJSON(json: any): EligibilityRequestServiceTypeCodes {
    return EligibilityRequestServiceTypeCodesFromJSONTyped(json, false);
}

export function EligibilityRequestServiceTypeCodesFromJSONTyped(json: any, ignoreDiscriminator: boolean): EligibilityRequestServiceTypeCodes {
    if (json == null) {
        return json;
    }
    return {
        
        'serviceTypeCode': json['serviceTypeCode'] == null ? undefined : json['serviceTypeCode'],
    };
}

export function EligibilityRequestServiceTypeCodesToJSON(json: any): EligibilityRequestServiceTypeCodes {
    return EligibilityRequestServiceTypeCodesToJSONTyped(json, false);
}

export function EligibilityRequestServiceTypeCodesToJSONTyped(value?: EligibilityRequestServiceTypeCodes | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serviceTypeCode': value['serviceTypeCode'],
    };
}

